import Urls from '../../utils/urlStrings'
import service from '../../utils/service'
import { MICROSERVICES}from '../../utils/constants'

export class ApplicationService {

    async getApplicationsPaginated(data_size,page,status) {
    try {
      const response = await service.get(Urls.getApiUrl( `application/get_applications?data_size=${data_size}&page=${
        page > 0 ? page - 1 : 0
      }&status=${status}`, MICROSERVICES.HECOSDPMANAGER),)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }


    async getApplicationBySiteId(site_id) {
    try {
      const response = await service.get(Urls.getApiUrl(`application/site/${site_id}`, MICROSERVICES.HECOSDPMANAGER),)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async approveApplicationBySiteId(site_id) {
    try {
      const response = await service.post(Urls.getApiUrl(`application/site/${site_id}/status?status=approved`, MICROSERVICES.HECOSDPMANAGER),
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

    async rejectApplicationBySiteId(site_id,reason) {
    try {
      const response = await service.post(Urls.getApiUrl(`application/site/${site_id}/status?reason=${reason}&status=rejected`, MICROSERVICES.HECOSDPMANAGER),
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
      async createApplicationBySiteId(form_data,config) {
    try {
      const response = await service.post(Urls.getApiUrl('application/submit', MICROSERVICES.HECOSDPMANAGER), form_data,config)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

        async updateApplicationBySiteId(site_id,form_data,config) {
    try {
      const response = await service.put(Urls.getApiUrl(`application/site/${site_id}/update`, MICROSERVICES.HECOSDPMANAGER), form_data,config
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const applicationService = new ApplicationService()
